import {AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {isObject} from 'app/core/helpers/object';

import {environment} from '../../../environments/environment';

@Directive({
    selector: '[customProperty]',
})
export class CustomPropertyDirective implements AfterViewInit, OnChanges {
    @Input() customProperty = {};

    viewInitialized = false;

    constructor(private elRef: ElementRef) {}

    setCustomProperties(newValue, oldValue = {}) {
        if (!isObject(newValue)) {
            /* istanbul ignore next */
            if (!environment.production) {
                console.warn(`[customProperty] Directive expect object to be passed. '${newValue}' was passed instead`);
            }
            newValue = {};
        }
        if (!isObject(oldValue)) {
            oldValue = {};
        }
        const element = <HTMLDivElement>this.elRef.nativeElement;
        // to remove
        Object.keys(oldValue)
            .filter(key => !newValue[key])
            .forEach(key => element.style.removeProperty(key));

        // to set
        Object.keys(newValue).forEach(key => element.style.setProperty(key, newValue[key]));
    }

    ngAfterViewInit() {
        this.viewInitialized = true;
        this.setCustomProperties(this.customProperty);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.viewInitialized) {
            this.setCustomProperties(changes.customProperty.currentValue, changes.customProperty.previousValue);
        }
    }
}
